import { render, staticRenderFns } from "./AfterSurveyQuestionLast.vue?vue&type=template&id=06ec8e06"
import script from "./AfterSurveyQuestionLast.vue?vue&type=script&lang=js"
export * from "./AfterSurveyQuestionLast.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports